// frontend/src/components/CallProgress.js
import React, { useMemo } from 'react';
import { Container, Step } from 'semantic-ui-react';
import socket from '../utils/SocketIo';

const FLOW = ['ringing', 'enqueue', 'transferring', 'answered']; // order matters

function normalizeStatus(raw) {
  const s = String(raw || '').toLowerCase();
  if (s === 'queued' || s === 'enqueued') return 'enqueue';
  if (s === 'dialing') return 'transferring';
  // treat 'completed' as 'answered' for this strip (up to enqueue + through connect)
  if (s === 'completed') return 'answered';
  return s;
}

function CallProgress({ call }) {
  const status = useMemo(() => normalizeStatus(call?.CallStatus), [call]);
  const currentIdx = useMemo(() => Math.max(0, FLOW.indexOf(status)), [status]);

  function answerCall(sid) {
    if (!sid) return;
    socket.client.emit('answer-call', { sid });
  }

  // helpers for each step
  const isActive = (i) => i === currentIdx;
  const isCompleted = (i) => i < currentIdx;
  const isDisabled = (i) => i > currentIdx;

  return (
    <Container>
      <Step.Group fluid>

        {/* 0) Ringing */}
        <Step
          icon='phone'
          title='Ringing'
          description={call?.CallSid || 'Incoming call'}
          active={isActive(0)}
          completed={isCompleted(0)}
          disabled={false}
          onClick={() => status === 'ringing' && answerCall(call?.CallSid)}
        />

        {/* 1) In queue */}
        <Step
          icon='cogs'
          title='In queue'
          description='User waiting in queue'
          active={isActive(1)}
          completed={isCompleted(1)}
          disabled={isDisabled(1)}
        />

        {/* 2) Transferring */}
        <Step
          icon='exchange'
          title='Transferring'
          description='Connecting to agent'
          active={isActive(2)}
          completed={isCompleted(2)}
          disabled={isDisabled(2)}
        />

        {/* 3) Answered */}
        <Step
          icon='headphones'
          title='Answered'
          description='Agent connected'
          active={isActive(3)}
          completed={isCompleted(3)}
          disabled={isDisabled(3)}
        />

        {/* Optional: keep Hang up as a static end-cap (no status drive) */}
        <Step
          icon='times'
          title='Hang up'
          description='Missed call'
          disabled
        />
      </Step.Group>
    </Container>
  );
}

export default CallProgress;


/*import React from 'react';
import { Container, Step } from 'semantic-ui-react';
import socket from '../utils/SocketIo';

function CallProgress({ call }) {
  function answerCall(sid) {
    socket.client.emit('answer-call', { sid });
  }
  return (
    <Container>
      <Step.Group fluid>
        <Step
          icon='phone'
          title='Ringing'
          description={call.CallSid}
          active={call.CallStatus === 'ringing'}
          completed={call.CallStatus !== 'ringing'}
        />
        <Step
          icon='cogs'
          title='In queue'
          description='User waiting in queue'
          active={call.CallStatus === 'enqueue'}
          disabled={call.CallStatus === 'ringing'}
          onClick={() => answerCall(call.CallSid)}
        />
        <Step
          icon='exchange'
          title='Transferring'
          description='Connecting to agent'
          active={call.CallStatus === 'transferring' || call.CallStatus === 'dialing'}
          disabled={!(call.CallStatus === 'transferring' || call.CallStatus === 'dialing')}
          completed={call.CallStatus === 'answered'}
        />

        <Step
          icon='headphones'
          title='Answered'
          description='Answer by John'
          disabled={
            call.CallStatus === 'ringing' || call.CallStatus === 'enqueue'
          }
        />
        <Step icon='times' title='Hang up' description='Missed call' />
      </Step.Group>
    </Container>
  );
}

export default CallProgress;
*/